"use client";

import { motion } from "framer-motion";
import VerticalScrollCards from "./VerticalScrollCards";
import Products from "./Products";
import CaseStudies from "./CaseStudies";

interface CombinedServicesProps {
    initialProducts?: any[];
    initialStudies?: any[];
}

export default function CombinedServices({ initialProducts, initialStudies }: CombinedServicesProps) {
    return (
        <div className="w-full bg-white text-black">
            {/* <VerticalScrollCards /> */}
            <Products initialProducts={initialProducts} />
            <CaseStudies initialStudies={initialStudies} />
        </div>
    );
}
